<template>
	<div class="category-animation-7-bg abs">
		<!--<transition name="fade-long">
			<div v-if="withFade" class="category-animation-5-bg__fade"></div>
		</transition>-->
		<video autoplay
			   muted
			   loop
			   playsinline
			   class="anim-fade-in"
			   @loadeddata="withFade=false">
			<source src="@/assets/animations/7/bg.mp4" type="video/mp4">
		</video>
	</div>
</template>

<script>
	export default {
		name: "category-animation-7-bg",
		components: {},
		data: () => {
			return {
				withFade: false,
			}
		},
	}
</script>

<style lang="scss">
	.category-animation-7-bg {
		top: 35%;
		width: 90vw;
		height: 400px;

		/*@include up($md) {
			height: 280px;
		}

		@include up($lg) {
			height: 320px;
		}*/

		video {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

</style>